import React from 'react';

import { 
    FaFacebookF,
    FaTelegramPlane,
    FaInstagram,
    FaWhatsapp,
  } from "react-icons/fa";

  export default {
    links : [
        {
            icon: <FaFacebookF />,
            url: "https://www.facebook.com/Patlab-546458326283634"
        },
        {
            icon: <FaInstagram />,
            url: "https://www.instagram.com/patlab_chile/"
        },
        {
            icon: <FaTelegramPlane />,
            url: "https://telegram.me/patlabChile"
        },
        {
            icon: <FaWhatsapp />,
            url: "https://api.whatsapp.com/send?phone=56997032878&text=Hola,%20me%20gustar%C3%ADa%20saber%20m%C3%A1s%20sobre%20sus%20servicios"
        }
    ]
  }